import MapPlaceAutocompleteFilter from './PlaceAutocompleteFilter'

export default function PostalCodeFilter({
  filterPostalCode,
  filterState,
  updateFilter,
}: {
  filterPostalCode: string[]
  filterState: string[]
  updateFilter: (updates: Record<string, any>) => void
}) {
  return (
    <MapPlaceAutocompleteFilter
      label="Zip Code"
      searchType="postalCode"
      placeholder="Search zip codes..."
      selectedValues={filterPostalCode}
      allowedStates={filterState}
      filterKey="postalCodes"
      updateFilter={updateFilter}
    />
  )
}
